<template>
    <div>
        <!-- TODO: query search result from backend -->
        <v-select
            ref="vselectDiscount"
            v-bind="$attrs"
            v-on="$listeners"
            :options="sortedOptions"
            :filterable="false"
            :value="value"
            :searchable="true"
            @search="onSearch"
            @input="onChange"
            :clearSearchOnBlur="() => false"
        >
            <template slot="no-options">
                <span v-if="!loading">No matches found</span>
                <span v-else></span>
            </template>
            <template #list-header>
                <div class="menu">
                    <a
                        @click="addDiscount"
                        class="badge badge-success rounded-0"
                        >Add New</a
                    >
                    {{ search_text }}
                </div>
            </template>
            <div slot="option" slot-scope="option">
                <span style="white-space: normal;">
                    {{ option.label }}
                </span>
            </div>
        </v-select>

        <modal-new-discount
            ref="modalNewDiscount"
            @success="onSavedNewDiscount"
        />
    </div>
</template>

<script>
import vSelect from "vue-select";
import Fuse from "fuse.js";
import { get, forEach } from "lodash";
import DiscountService from "@/services/discount";

export default {
    components: {
        vSelect,
        ModalNewDiscount: () =>
            import("@/module/settings/discounts/modal-create-update.vue")
    },
    props: {
        value: [Object],
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            search_text: "",
            prefetch_options: [],
            loading: false,
            showNewDiscount: false
        };
    },
    computed: {
        sortedOptions() {
            let self = this;
            let results = self.prefetch_options.length
                ? self.prefetch_options
                : self.options.length
                ? self.options
                : [];

            if (self.search_text) {
                const searcher = new Fuse(results, {
                    shouldSort: true,
                    keys: ["label"],
                    threshold: 0.0
                });
                return searcher.search(self.search_text);
            } else {
                return results;
            }
        }
    },
    mounted() {
        this.getDiscounts();
    },
    methods: {
        focus() {
            this.$refs.vselectDiscount.$el.querySelector("input").focus();
        },
        addDiscount() {
            this.$refs.modalNewDiscount.open({
                isEditMode: false,
                isSingleMode: true,
                defaultName: this.search_text
            });
        },
        async getDiscounts() {
            this.prefetch_options = [];

            try {
                let res = await DiscountService.getDiscounts();

                let rawlist = get(res, "resource.data", []);
                let arr = [];
                forEach(rawlist, element => {
                    if (element.status == 1) {
                        arr.push({
                            value: element.id,
                            label: element.name
                        });
                    }
                });

                this.prefetch_options = arr;
            } catch (error) {
                this._message("Error : Unable to load discount", "danger");
            }
        },
        onChange(value) {
            if (value) {
                this.$emit("input", value);
            } else {
                this.onSearch("");
            }
        },
        onSearch(search) {
            this.search_text = search;
        },
        async onSavedNewDiscount(item) {
            await this.getDiscounts();
            this.$nextTick(() => {
                this.onSearch(item.name);
                this.$emit("input", {
                    value: item.id,
                    label: item.name
                });
            });
        }
    }
};
</script>
